import RecoveredBlackboards from './RecoveredBlackboards';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Device } from '@capacitor/device';
import { isNative } from '../../utils/platform';
import { getAppEventExists, postAppEvent } from '../../utils/appEvents';
import { getStableMachineId } from '../../utils/deviceId';

const Home = ({ lastRoomInfo }) => {
  const navigate = useNavigate();
  const [machineId, setMachineId] = useState('');

  useEffect(() => {
    let cancelled = false;
    let heartbeat = null;
    const start = async () => {
      const { id } = await getStableMachineId();
      if (!cancelled) setMachineId(id);
      let platform = 'web';
      let appVersion = '';
      if (isNative()) {
        try {
          const info = await Device.getInfo();
          platform = info.platform || 'native';
          appVersion = info.appVersion || '';
        } catch {}
      }
      try {
        const exists = await getAppEventExists(id);
        if (!exists) await postAppEvent({ deviceId: id, event: 'install', appVersion, platform });
      } catch {}
      localStorage.setItem('shep_install_reported', '1');
      heartbeat = window.setInterval(() => {
        void postAppEvent({ deviceId: id, event: 'heartbeat', appVersion, platform });
      }, 6 * 60 * 60 * 1000);
    };
    void start();
    return () => { cancelled = true; if (heartbeat) clearInterval(heartbeat); };
  }, []);

  const handleRejoin = () => {
    if (lastRoomInfo?.roomId) {
      navigate(`/rejoin/${encodeURIComponent(lastRoomInfo.roomId)}`);
    }
  };

  // Keep the page visually empty if that is the product design, but retain
  // stable device reporting and an accessible rejoin action when applicable.
  return <><RecoveredBlackboards /><main className="sr-only" aria-live="polite">
    <span>Device ID: {machineId}</span>
    {lastRoomInfo?.roomId && <button onClick={handleRejoin}>Rejoin meeting</button>}
  </main></>;
};

export default Home;

